import { AfterViewInit, Component, ElementRef, NgZone, ViewChild } from '@angular/core';
import { TvFeature } from 'src/app/data/enum/tv-feature';
import gsap from 'gsap';
import { LocalizationService } from 'src/app/service/localization.service';
import { RemoteControlService } from 'src/app/service/remote-control.service';
import createInitialPageTimeline from '../../utils/animation/initial-page-timeline';
import endPageTimeline from '../../utils/animation/end-page-timeline';
import FeaturePage from 'src/app/core/feature-page';
import { AnalyticsEvent, triggerEvent } from 'src/app/utils/analytics';
import { environment } from 'src/environments/environment';
import { ParameterService } from 'src/app/service/parameter.service';

@Component({
  selector: 'app-recommendations-page',
  templateUrl: './recommendations-page.component.html',
  styleUrls: ['./recommendations-page.component.scss'],
})
export class RecommendationsPageComponent extends FeaturePage implements AfterViewInit {
  @ViewChild('recommendationsRef') containerElementRef: ElementRef;

  private tvTimeline = gsap.timeline({ paused: true, defaults: { duration: 0.5 } });
  public moveTooltip: boolean = false;
  public baseHref = environment.baseHref;

  constructor(
    protected localizationService: LocalizationService,
    protected remoteControlService: RemoteControlService,
    protected parameterService: ParameterService,
    protected zone: NgZone,
  ) {
    super(
      localizationService,
      remoteControlService,
      parameterService,
      zone,
      TvFeature.RECOMMENDATIONS,
    );
  }

  handleLastStep() {
    gsap.delayedCall(1.5, () => endPageTimeline(this.containerElementRef).play());
    triggerEvent(AnalyticsEvent.recommendationsComplete);
  }

  handleRemoteSignal() {
    this.isRemoteDisabled = true;
    const nextStepIndex = this.stepIndex + 1;
    this.moveTooltip = nextStepIndex >= 1;
    this.tvTimeline.play();
    this.nextStep();

    if (this.stepIndex === 1) triggerEvent(AnalyticsEvent.recommendationsFirstInteraction);
  }

  setupTVTimeline(): void {
    this.tvTimeline
      .to('[data-transition="1"]', { autoAlpha: 0, duration: 0.5 })
      .to('[data-transition="2"]', { autoAlpha: 0, delay: 0.4, duration: 0.2 })
      .to('[data-transition="3"]', { autoAlpha: 0, duration: 0.3 })
      .to('[data-transition="4"]', { autoAlpha: 0, duration: 0.5 })
      .addPause()
      .to('[data-transition="5"]', { autoAlpha: 0 });
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.setupTVTimeline();
    createInitialPageTimeline(this.containerElementRef, this.isAbstract).play();
  }
}
